import GovPoolCreate from "./GovPoolModel/GovPoolCreate"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function PoolCreateObservable(data: GovPoolCreate) {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<string>("GovPool/CreateGovPool", params, "put")
}
